import { createFragment } from "@applant/fragment-scripts/fragment";

export * from './components/footer';
export * from './components/footerlink';
export * from './components/footerlinklist';

const { init } = createFragment();

export { init };